module.exports = __webpack_public_path__ + "img/tanom_banner.356d2e29.png";